/*
 * $Id:: notificationsSlice.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { createSlice } from '@reduxjs/toolkit';

import { NOTIFICATIONS_SLICE_NAME as SLICE_NAME } from './constants';

const DEFAULT_DURATION = 3000;

// Random number to change the key value of each notification.
let notificationCounter = 0;

export const slice = createSlice({
    name: SLICE_NAME,
    initialState: {
        notificationsQueue: [],
        defaultDuration: DEFAULT_DURATION,
    },
    reducers: {
        addNotification: (state, action) => {
            const { message, type } = action.payload || {};
            const notification = { ...action.payload, key: `${message}_${type}_${++notificationCounter}` };
            state.notificationsQueue = [...state.notificationsQueue, notification];
        },
        removeNotification: (state, action) => {
            state.notificationsQueue = state.notificationsQueue.filter((n) => n.key !== action.payload);
        },
    },
});

export const notificationsQueue = (state) => state[SLICE_NAME].notificationsQueue;
export const defaultDuration = (state) => state[SLICE_NAME].defaultDuration;

export default slice.reducer;
